<template>
  <loading v-if="loading" />
  <error-messages
    v-else-if="!loading && errorMessages.length > 0"
    :messages="errorMessages"
  />
  <empty-list
    v-else-if="!loading && errorMessages.length === 0 && items.length === 0"
    :srcImage="require('@/assets/images/ticket-empty.png')"
    btnText=""
  >
    <template v-slot:messages>
      <p>
        <strong>هیچ کاربری ثبت نشده است.</strong>
      </p>
    </template>
  </empty-list>
  <main-page-service v-else title="لیست کاربران" btnText="">
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      table-class="table-list-table"
      thead-tr-class="table-list-thead-tr"
      tbody-tr-class="table-list-tbody-tr"
    >
      <template #cell(isActive)="data">
        <b-badge v-if="data.item.isActive" variant="success">فعال</b-badge>
        <b-badge v-else variant="danger">غیر فعال</b-badge>
      </template>
      <template #cell(operations)="data">
        <b-container>
          <b-row>
            <b-col align-self="center">
              <b-button
                :to="`/admin/user/${data.item.id}/details`"
                size="sm"
                variant="outline-info"
              >
                <b-icon icon="eye-fill"></b-icon>
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-table>
  </main-page-service>
</template>

<script>
import MainPageService from "@/components/MainPageService/MainPageService";
import { userListAdmin } from "@/services/user";
import EmptyList from "@/components/EmptyList/EmptyList.vue";
import Loading from "@/components/Loading/Loading.vue";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";

export default {
  name: "TicketList",
  components: {
    MainPageService,
    EmptyList,
    Loading,
    ErrorMessages
  },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: "username",
          label: "نام کاربری",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "fullName",
          label: "نام",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "balance",
          label: "موجودی",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "isActive",
          label: "وضعیت حساب",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "registerDateTime",
          label: "تاریخ ثبت‌نام",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "lastLoginDateTime",
          label: "آخرین زمان ورود",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "operations",
          label: "عملیات",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      items: [],
      errorMessages: []
    };
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    getUserList: async function() {
      this.loading = true;
      const [error, data] = await userListAdmin();
      if (error) {
        this.errorMessages = error;
        this.loading = false;
      } else {
        if (data.apiStatus === 200) {
          data.apiData.map(item => {
            item["operation"] = "";
          });
          this.items = data.apiData;
          this.loading = false;
        } else {
          this.errorMessages = data.apiErrors;
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style></style>
